import React from 'react';
import styles from './style.module.scss';
import classNames from 'classnames';
import { useSelector } from 'react-redux';
const CustomTab = ({ isFull, tabs, activeTab, handleActiveTab, NoActiveBorder, noBottomBorder, firstTabMargin, tabItemStyle, isLeft, isProfileTabs }) => {
    const {
        theme: { theme }
    } = useSelector((state) => state.root);
    return (
        <div
            className={classNames(
                noBottomBorder ? styles.TabsContainerNoBorderBottom : styles.TabsContainer,
                isProfileTabs ? 'justify-content-between justify-content-sm-start' : 'justify-content-start'
            )}
            style={isFull ? { width: '100%' } : { width: '100%' }}
        >
            <div className={classNames('d-flex align-items-center justify-content-start', styles.TabItemContainer)}>
                {tabs?.map((tab, ind) => {
                    return (
                        <div
                            className={classNames(styles.ActiveTabContainer, ind === 0 && firstTabMargin ? firstTabMargin : '', isProfileTabs && styles.NoPaddingContainer)}
                            style={isLeft ? { textAlign: 'left', paddingRight: '30px' } : { textAlign: 'center' }}
                            key={ind}
                        >
                            <label
                                className={classNames(tab === activeTab ? styles.ActiveTab : styles.InActiveTab, tabItemStyle ? tabItemStyle : '', `${theme}FontColor`)}
                                key={ind}
                                onClick={() => {
                                    handleActiveTab?.(tab);
                                }}
                            >
                                {tab}
                                {tab === activeTab && !NoActiveBorder && <div className={classNames(styles.ActiveTabThumb)} />}
                            </label>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default CustomTab;
